import {
  Typography,
  FormControl,
  Container,
  InputLabel,
  Input,
  Button,
} from "@mui/material";

import { useParams } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";

import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

import { db } from "../firebase.config";
import { toast } from "react-toastify";

import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { formGenres, formTopics, formItems } from "../formInfo";
import { getAuth } from "firebase/auth";
import Spinner from "../components/Spinner.jsx";

import TemplateTray from "../components/TemplateTray";
import { Dropzone, FileItem } from "@dropzone-ui/react";
import Croppie from "croppie";
import initialNewTopicData from "../initialNewTopicData";
import isBase64 from "is-base64";

/* Page = /topic/edit/:templateId */
function EditTemplate(props) {
  const { appState, setAppState, genres } = props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();
  const params = useParams();

  const [files, setFiles] = useState([]);
  const [cDiv, setcDiv] = useState(null);
  const [c, setC] = useState(null);
  // const [crop, setCrop] = useState({ aspect: 1 / 1 });
  // const [cHTML, setcHTML] = useState("");

  const [formData, setFormData] = useState({
    topicName: "",
    newItem: {
      desc: "",
      imageUrl: "",
    },
    formItems: [],
    formImageSrcs: [],
    showReactCrop: false,
    showReactDrop: true,
  });

  useEffect(() => {
    // const croppieDemo = document.getElementById("croppie-demo");
    const croppieDemo = document.getElementById("croppie-demoo");
    setcDiv(croppieDemo);
    const croppieOptions = {
      showZoomer: true,
      enableOrientation: true,
      mouseWheelZoom: "ctrl",
      enforceBoundary: false,
      viewport: {
        width: 150,
        height: 150,
        type: "square",
      },
      boundary: {
        width: "50vw",
        height: "50vh",
      },
    };
    const newC = new Croppie(croppieDemo, croppieOptions);
    setC(newC);
    // setcHTML(croppieDemo.innnerHTML);

    if (!appState.topicDraft) {
      setAppState((prevState) => ({
        ...prevState,
        topicDraft: { ...initialNewTopicData.topicDraft },
      }));
    }
    //eslint-disable-next-line
  }, [setAppState]);

  function slugify(string) {
    const a =
      "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
    const b =
      "aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");

    return (
      string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        //eslint-disable-next-line
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        //eslint-disable-next-line
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "")
    ); // Trim - from end of text
  }

  // Store image in firebase
  const storeImage = async (imageBlob, imageDesc) => {
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const fileName = `${auth.currentUser.uid}-${slugify(
        imageDesc
      )}-${uuidv4()}`;

      const storageRef = ref(storage, "images/" + fileName);

      const uploadTask = uploadBytesResumable(storageRef, imageBlob);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
            default:
              break;
          }
        },
        (error) => {
          reject(error);
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          console.log("image uploaded");
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
  };

  useEffect(() => {
    const buildItems = (formItems) => {
      let itemObjects = {};
      let newItemIdArray = [];
      let newItemCount = 0;
      if (formItems) {
        formItems.forEach((formItem, index) => {
          let itemName = "item-" + index;
          newItemIdArray.push(itemName);
          let itemObject = {
            [itemName]: {
              id: itemName,
              imageUrl: formItem.imageUrl,
              altText: formItem.desc,
              content: "test-" + index,
            },
          };
          itemObjects = { ...itemObjects, ...itemObject };
          newItemCount++;
        });
        let firstRow = appState.newDraft.rows["row-draft"];
        let newRows = appState.newDraft.rows;
        // let draftCount = 0;
        // if (appState.drafts && Object.keys(appState.drafts).length > 0) {
        //   draftCount = Object.keys(appState.drafts).length;
        // }
        newRows[firstRow.id] = { ...firstRow, itemIds: newItemIdArray };
        setAppState((prevState) => ({
          ...prevState,
          newDraft: {
            itemCount: newItemCount,
            rows: newRows,
            draft: true,
            items: itemObjects,
            rowOrder: appState.rowOrder,
            title: appState.tierListTopic,
            userRef: auth.currentUser.uid,
          },
          // drafts: {
          //   ...prevState.drafts,
          //   ["draft-" + draftCount]: {
          //     itemCount: newItemCount,
          //     rows: newRows,
          //     draft: true,
          //     genreRef: appState.tierListGenre,
          //     items: itemObjects,
          //     author: prevState.userRef,
          //     rowOrder: newRows,
          //     title: appState.tierListTopic,
          //   },
          // },
          itemCount: newItemCount,
          rows: newRows,
          items: itemObjects,
        }));
        return itemObjects;
      }
    };
    const fetchTemplate = async () => {
      try {
        setLoading(true);
        // Get Reference
        const tierListTemplateRef = doc(db, "formItems", params.templateId);
        const tierListDraftDocSnap = await getDoc(tierListTemplateRef);
        const templateData = tierListDraftDocSnap.data();
        /* Data format of templateData.items = {desc, imageUrl} , have to build item array*/

        const newItems = buildItems(templateData.items);
        const newRowOneIds = [];
        Object.keys(newItems).forEach((itemName) => {
          newRowOneIds.push(itemName);
        });

        // update state here
        setAppState((prevState) => ({
          ...prevState,
          tierListGenre: {
            id: templateData.genreId,
            name: genres[templateData.genreId]?.name,
          },
          tierListTopic: tierListDraftDocSnap.id,
          topicDraft: {
            ...prevState.topicDraft,
            name: templateData.name,
            id: tierListDraftDocSnap.id,
            genreId: templateData.genreId,
            rows: {
              ...prevState.topicDraft.rows,
              "row-draft": {
                ...prevState.topicDraft.rows["row-draft"],
                itemIds: newRowOneIds,
              },
            },
            items: newItems,
          },
          fetchedTopic: templateData,
        }));

        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
        toast.error("Could not fetch Tier List");
      }
    };
    fetchTemplate();
    // }, []);
  }, [
    params.templateId,
    navigate,
    genres,
    setAppState,
    appState.newDraft.rows,
    appState.rowOrder,
    appState.tierListTopic,
    auth.currentUser?.uid,
  ]);

  const onChange = (e) => {
    if (e.target.name === "tierListGenre") {
      setAppState((prevState) => ({
        ...prevState,
        tierListGenre: {
          id: e.target.value,
          name: genres[e.target.value].name,
          // name: appState.genres[e.target.value].name,
        },
        tierListTopic: "DEFAULT",
      }));
    }
    if (e.target.name === "desc") {
      setFormData((prevState) => ({
        ...prevState,
        newItem: {
          ...prevState.newItem,
          [e.target.name]: e.target.value,
        },
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const onDrop = (e) => {
    console.log("image dropped!");
    console.log("e :", e[0]);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(e[0].file);
    fileReader.addEventListener("load", function () {
      console.log("c :", c);
      console.log(this.result);
      c.bind({ url: this.result });
      // setFormData((prevState) => ({
      //   ...prevState,
      //   formImageSrcs: [...prevState.formImageSrcs, this.result],
      // }));
    });

    // show crop
    setFormData((prevState) => ({
      ...prevState,
      showReactCrop: true,
      showReactDrop: false,
    }));
    cDiv.classList.add("show-croppie");
  };

  const updateFiles = (incommingFiles) => {
    //do something with the files
    setFiles(incommingFiles);
    //even your own upload implementation
  };
  const removeFile = (id) => {
    setFiles(files.filter((x) => x.id !== id));
  };

  // Confirm that url is valide base64
  const checkURL = (base64str_img) => {
    if (isBase64(base64str_img, { mimeRequired: true })) {
      console.log("Valid base64 image");
      return true;
    }
    console.log("Is not valid base64");
    return false;
  };

  const addItem = async () => {
    console.log("ran add item");
    setLoading(true);
    let base64 = await onResult();
    const newFormData = {
      ...formData,
      newItem: {
        ...formData.newItem,
        imageUrl: base64,
      },
      formImageSrcs: [...formData.formImageSrcs, base64],
    };
    console.log("base64 :", base64);
    if (
      newFormData.newItem.desc === "" ||
      newFormData.newItem.imageUrl === ""
    ) {
      toast.error("Fields cannot be empty");
      setLoading(false);
      return;
    } else if (!checkURL(newFormData.newItem.imageUrl)) {
      toast.error("Not a valid image URL");
      setLoading(false);
      return;
    }
    console.log("newFormData :", newFormData);
    const res = await fetch(newFormData.newItem.imageUrl);
    const blob = await res.blob();
    const imageUpload = await storeImage(blob, newFormData.newItem.desc);
    let itemObject = {
      desc: newFormData.newItem.desc,
      imageUrl: imageUpload,
    };
    const newItemArray = [itemObject];
    cDiv.classList.remove("show-croppie");
    setFormData({
      ...newFormData,
      formItems: newItemArray,
      showReactDrop: true,
      showReactCrop: false,
    });
    setFiles([]);
    console.log("formData.newItem.imageUrl :", formData.newItem.imageUrl);
    resetItemInputs();
    setLoading(false);
  };

  const resetItemInputs = () => {
    setFormData((prevState) => ({
      ...prevState,
      newItem: {
        desc: "",
        imageUrl: "",
      },
    }));
  };

  const onResult = (e) => {
    let promise = new Promise((res, rej) => {
      (async () => {
        try {
          const base64 = await c.result("base64");
          console.log("on result donzoed");
          return res(base64);
        } catch (error) {
          return rej(error);
        }
      })();
    });
    return promise;
  };

  const removeImage = (e) => {
    cDiv.classList.remove("show-croppie");
    setFormData((prevState) => ({
      ...prevState,
      showReactCrop: false,
      showReactDrop: true,
    }));
    setFiles([]);
  };

  return (
    <Container>
      {loading && <Spinner />}
      <Typography variant="h1" component="h1">
        Create Topic
      </Typography>
      <p>I see you've choosen the genre {appState.tierListGenre.name}</p>
      <label htmlFor="tierListGenre">
        Choose a Genre {appState.topicDraft?.genre}
      </label>
      <Typography variant="h5" component="h5" sx={{ alignSelf: "center" }}>
        <label htmlFor="tier-list-title">
          Topic Name: {appState.topicDraft?.name}
        </label>
      </Typography>
      <form>
        {/* Testing to see if image source URLS will display */}
        {/* {formData.formImageSrcs?.map((imgSrc) => {
          return <img key={imgSrc} src={imgSrc} alt="images"></img>;
        })} */}

        {/* Display croppie-demo here */}
        <div id="croppie-demoo"></div>

        {formData.showReactDrop && (
          <Dropzone
            onDrop={onDrop}
            onChange={updateFiles}
            label={"Drop File here"}
            value={files}
          >
            {files.map((file) => (
              <FileItem
                preview
                {...file}
                onDelete={removeFile}
                key={file.id}
                info
              />
            ))}
          </Dropzone>
        )}

        {formData.showReactCrop && (
          <FormControl>
            <p>Should show react cropper</p>
          </FormControl>
        )}

        {/* <FormControl>
          <InputLabel htmlFor="imageUrl" variant="filled">
            Enter an Image Url
          </InputLabel>
          <Input
            name="imageUrl"
            id="imageUrl"
            value={formData.newItem.imageUrl}
            aria-describedby="imageUrl-helper-text"
            onChange={onChange}
          />
        </FormControl> */}
        <FormControl>
          <InputLabel htmlFor="desc" variant="filled">
            Enter an Image Description
          </InputLabel>
          <Input
            name="desc"
            id="desc"
            aria-describedby="desc-helper-text"
            value={formData.newItem.desc}
            onChange={onChange}
          />
        </FormControl>

        <FormControl>
          <Button
            onClick={addItem}
            variant="contained"
            sx={{ textTransform: "none" }}
          >
            Add Item Test
          </Button>
        </FormControl>

        {formData.showReactCrop && (
          <FormControl>
            <Button variant="contained" color="secondary" onClick={removeImage}>
              Remove image
            </Button>
          </FormControl>
        )}
      </form>
      {appState.fetchedTopic && (
        <TemplateTray
          formData={formData}
          setFormData={setFormData}
          appState={appState}
          setAppState={setAppState}
        ></TemplateTray>
        // <TierRowTrayEditVersion
        //   formData={formData}
        //   appState={appState}
        //   setAppState={setAppState}
        // ></TierRowTrayEditVersion>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          /* appState.tierListGenre has id & name property */
          setAppState((prevState) => ({
            ...prevState,
            tierListTopic: params.templateId,
          }));
          navigate("/tierlist/new");
        }}
      >
        <Button type="submit" color="success" variant="contained">
          Submit Topic
        </Button>
      </form>
    </Container>
  );
}

export default EditTemplate;
